interface FooterLink {
    label: string;
    stringKey: string;
    trackingId?: string;
}
export const FOOTER_ID = 'footer_component';

const footerMap: {[key: string]: FooterLink} = {
    About: {label: 'About', stringKey: 'footer_about', trackingId: 'About'},
    Help: {label: 'Help', stringKey: 'footer_help', trackingId: 'Help'},
    Faq: {label: 'Faq', stringKey: 'footer_faq', trackingId: 'FAQ'},
    Impressum: {
        label: 'Impressum',
        stringKey: 'footer_impressum',
        trackingId: 'Imprint'
    },
    Terms: {
        label: 'Terms',
        stringKey: 'footer_terms',
        trackingId: 'Terms and Conditions'
    },
    TermsPlus: {
        label: 'TermsPlus',
        stringKey: 'footer_termsOfUse_Plus',
        trackingId: 'Terms and Conditions Plus'
    },
    Privacy: {
        label: 'Privacy',
        stringKey: 'footer_privace',
        trackingId: 'Privacy Policy'
    },
    Media: {label: 'Media', stringKey: 'footer_media', trackingId: 'Media'},
    News: {label: 'News', stringKey: 'footer_news', trackingId: 'News'},
    Redeem: {label: 'Redeem', stringKey: 'footer_redeem', trackingId: 'Redeem'},
    Trademark: {label: 'footer_trademark', stringKey: 'footer_trademark'},
    DaznForBusiness: {
        label: 'DaznForBusiness',
        stringKey: 'footer_DAZN_for_Business',
        trackingId: 'Dazn for Business'
    },
    Accessibility: {
        label: 'Accessibility',
        stringKey: 'footer_accessibility',
        trackingId: 'Accessibility'
    },
    BarFinder: {
        label: 'BarFinder',
        stringKey: 'DAZN_Bar_Finder',
        trackingId: 'Bar Finder'
    },
    GiftCards: {
        label: 'GiftCards',
        stringKey: 'Gift_Card',
        trackingId: 'Gift Cards'
    },
    Cancel: {
        label: 'Cancel',
        stringKey: 'footer_cancelLink',
        trackingId: 'Cancel'
    },
    Offers: {
        label: 'Offers',
        stringKey: 'footer_offers',
        trackingId: 'footer offers'
    },
    Cgu: {
        label: 'Cgu',
        stringKey: 'footer_cgu',
        trackingId: 'footer cgu'
    },
    AboutUsNews: {
        label: 'theedit_aboutUs_footer',
        stringKey: 'theedit_aboutUs_footer'
    },
    ContactUsNews: {
        label: 'theedit_contactUs_footer',
        stringKey: 'theedit_contactUs_footer'
    }
};

export {footerMap};
